// extracted by mini-css-extract-plugin
export default {"home__container":"Home_home__container__5DMcK"};